import React, { useState } from 'react';
import './DrawerTemplate.scss';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import store from 'store';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AskModal from '../../common/AskModal';
import Icon from 'components/Icon';
import { KEY } from 'utils/constants/storageKey';
import { ReactComponent as IconCommonArrow24Right } from '../../../assets/iconCommonArrow24Right.svg';
import { ReactComponent as IconDrawerUser } from '../../../assets/iconDrawerUser.svg';
import { ReactComponent as IconDrawerVersion } from '../../../assets/iconDrawerVersion.svg';
import { ReactComponent as IconDrawerTerms } from '../../../assets/iconDrawerTerms.svg';
import { ReactComponent as IconDrawerOpenSource } from '../../../assets/iconDrawerOpenSource.svg';
import { ReactComponent as IconDrawerLogin } from '../../../assets/iconDrawerLogin.svg';
import { ReactComponent as IconDrawerLogout } from '../../../assets/iconDrawerLogout.svg';
import { ReactComponent as KakaoIcon } from '../../../assets/kakao_talk_bg_brown.svg';
import { ReactComponent as IconDrawerPassword } from '../../../assets/iconDrawerPassword.svg';
import { ReactComponent as IconDrawerDropout } from '../../../assets/iconDrawerDropout.svg';

const DrawerTemplate = ({
  activeUser,
  onCloseDrawer,
  onShowVersion,
  onAutoLogin,
  autoLogin,
  logoutState,
  onLogout,
  onLogoutConfirm,
  dropoutState,
  onDropout,
  onDropoutConfirm,
  onAddKakaoChannel,
  language,
  authType,
  onClickCoupons,
}) => {
  const { t, i18n } = useTranslation('drawer');
  const { coupons } = useSelector(({ user }) => ({ coupons: user.coupons }));
  const [accountState, setAccountState] = useState(false);
  const onToggleAccountState = () => {
    setAccountState(accountState ? false : true);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
      className="DrawerTemplate bg_paleLavender"
    >
      <div>
        <div className="DrawerTemplate__headerBox bg_white">
          <div className="nickname text_greyishBrown">
            {activeUser && authType !== 'KB_USER' ? activeUser.nickname : null}
          </div>
          <div className="closeBtn" onClick={onCloseDrawer}>
            <Icon name="close-black" size={28} />
          </div>
        </div>

        <div
          className="DrawerTemplate__coupons text_greyishBrown bg_white"
          onClick={() => coupons.length > 0 && onClickCoupons()}
        >
          {t('availableCoupons')}
          <span data-nocoupon={coupons.length === 0}>{coupons.length}</span>
        </div>

        <div className="DrawerTemplate__accountBtnBlock">
          <div className="accountBtnBox" onClick={onToggleAccountState}>
            <IconDrawerUser />
            <div className="title font_regular text_greyishBrown">
              {t('accountManagement')}
            </div>
            <div className={'next ' + (accountState ? '' : 'hidden')}>
              <IconCommonArrow24Right />
            </div>
          </div>
          <div className={'subBtnBox ' + (accountState ? '' : 'hidden')}>
            {authType === 'EMAIL' && (
              <div className="subItem">
                <Link to="/account/update/password">
                  <IconDrawerPassword />
                  <div className="title font_regular text_brownishGrey">
                    {t('changePassword')}
                  </div>
                </Link>
              </div>
            )}
            <div className="subItem" onClick={onDropout}>
              <IconDrawerDropout />
              <div className="title font_regular text_brownishGrey">
                {t('dropOut')}
              </div>
            </div>
          </div>
          <div className="accountBtnBox" onClick={onShowVersion}>
            <IconDrawerVersion />
            <div className="title font_regular text_greyishBrown">
              {t('versionInfo')}
            </div>
          </div>
          <Link to="/terms">
            <div className="accountBtnBox">
              <IconDrawerTerms />
              <div className="title font_regular text_greyishBrown">
                {t('termsInfo')}
              </div>
            </div>
          </Link>
          <Link to="/opensource">
            <div className="accountBtnBox">
              <IconDrawerOpenSource />
              <div className="title font_regular text_greyishBrown">
                {t('opensourceInfo')}
              </div>
            </div>
          </Link>
          <div className="divider"></div>
          <div className="accountBtnBox">
            <IconDrawerLogin />
            <div className="title font_regular text_greyishBrown">
              {t('autoLogin')}
            </div>
            <div
              onClick={onAutoLogin}
              className={`autoLoginBox bg_paleGrey ${autoLogin ? null : 'off'}`}
            >
              <div className="toggleBtn"></div>
            </div>
          </div>
          <div className="accountBtnBox" onClick={onLogout}>
            <IconDrawerLogout />
            <div className="title font_regular text_greyishBrown">
              {t('logout')}
            </div>
          </div>
          {i18n.language === 'ko' && (
            <>
              <div className="divider"></div>
              <div className="accountBtnBox" onClick={onAddKakaoChannel}>
                <KakaoIcon />
                <div className="title font_regular text_greyishBrown">
                  {t('addKakaoChannel')}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <AskModal
        visible={dropoutState}
        description={
          (activeUser ? activeUser.nickname : '') + t('dropOutConfirm')
        }
        onConfirm={onDropoutConfirm}
        onCancel={onDropout}
      />
      <AskModal
        visible={logoutState}
        description={t('logoutConfirm')}
        onConfirm={onLogoutConfirm}
        onCancel={onLogout}
      />
    </motion.div>
  );
};

export default DrawerTemplate;
